import { render, staticRenderFns } from "./seaBookingCopyWindow.vue?vue&type=template&id=36d9d52a&scoped=true&"
import script from "./seaBookingCopyWindow.vue?vue&type=script&lang=js&"
export * from "./seaBookingCopyWindow.vue?vue&type=script&lang=js&"
import style0 from "./seaBookingCopyWindow.vue?vue&type=style&index=0&id=36d9d52a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d9d52a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d9d52a')) {
      api.createRecord('36d9d52a', component.options)
    } else {
      api.reload('36d9d52a', component.options)
    }
    module.hot.accept("./seaBookingCopyWindow.vue?vue&type=template&id=36d9d52a&scoped=true&", function () {
      api.rerender('36d9d52a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/seaBookingCopyWindow.vue"
export default component.exports